export default {
  methods: {
    // Used when user wants to pick color for something.
    // Adjust classes and logic condition accordingly.
    $backgroundClassPicker(color) {
      let cssClass;
      const isYellow = color === 'yellow';
      const isWhite = color === 'white';
      const isGreen = color === 'green';
      const isTransparent = color === 'transparent';

      switch (true) {
        case isYellow:
          cssClass = 'bg-yellow';
          break;
        case isGreen:
          cssClass = 'bg-green';
          break;
        case isWhite:
          cssClass = 'bg-white';
          break;
        case isTransparent:
          cssClass = 'bg-transparent';
          break;
        default:
          cssClass = 'bg-transparent';
          break;
      }

      return cssClass;
    }
  }
};
